import { authReq } from '@/utils/http'

const urlPrefix = '/proxy'

// 获取应用分类标签（默认返回根目录标签）
const getAppCategories = (data = {}) => {
  return authReq.post(urlPrefix + '/p/api/v1/app/getCategory', {
    pageNum: data.page,
    pageSize: data.pageSize || 10,
    step: 'start',
    condition: data.condition || {}
  })
}

/*
 * 添加应用分类标签
 *  {
 *    "app_category_name_i18n": [
 *      {
 *        "lang": "zh-CN",    // 语言,简体中文
 *        "name": "数据分析"  // 对应语言的名称
 *      },
 *      {
 *         "lang": "zh-TW", // 台湾繁体
 *         "name": "分析資料"
 *      },
 *      {
 *         "lang": "en-US", // 英语
 *         "name": "Analytics"
 *      }
 *    ],
 *    "level": 0,             // 分类层级，0为根
 *    "father_category_id": 0 // 父级分类ID，0为根
 *  }
 */
const addAppCategory = (data) => {
  return authReq.post(urlPrefix + '/p/api/v1/app/addCategory', {
    'app_category_name_i18n': data.i18nName,
    'father_category_id': data.parentId,
    level: data.level
  })
}

// 修改应用分类标签
const editAppCategory = (data) => {
  return authReq.post(urlPrefix + '/p/api/v1/app/editCategory', {
    'app_category_id': data.categoryId,
    'app_category_name_i18n': data.i18nName,
    'father_category_id': data.parentId,
    level: data.level
  })
}

// 获取应用列表
const getApps = (data) => {
  return authReq.post(urlPrefix + '/p/api/v1/app/getAppListInner', {
    pageNum: data.page,
    pageSize: data.pageSize,
    step: 'start',
    condition: data.condition || {}
  })
}
/*
 * 添加应用
 *
 *  {
 *      "app_module_name": "Dashboard", // 前端对应模块名称
 *      "app_name_i18n": [
 *          {
 *              "lang": "zh-CN",    // 语言,简体中文
 *              "name": "概览"      // 对应语言的名称
 *          },
 *          {
 *              "lang": "zh-TW",    // 台湾繁体
 *              "name": "儀表板"
 *          },
 *          {
 *              "lang": "en-US",    // 英语
 *              "name": "Dashboard"
 *          }
 *      ],
 *      "package": [
 *          {
 *              "market_price": 198888, // 市场价（单位：分）
 *              "discount_price": 0,    // 折扣价（单位：分）
 *              "name": "永久",         // 套餐时间长名称
 *              "duration": 3153600000  // 时长 (单位：秒) 3153600000 为100年
 *          }
 *      ],
 *      "is_publish": 1,        // 是否公开，0 不公开 1 公开
 *      "app_category_id": 101, // 分类ID
 *      "app_type": "user",     // 应用类型 user 用户应用 agent 代理商应用
 *      "intro": "概览功能可查看整体运营情况",  // 应用介绍
 *      "remarks": "概览",      // 备注
 *      "img": "",              // 图标
 *      "intro_detail": []      // 介绍详情，图片数组
 *  }
 *
 */
const addApp = (data) => {
  return authReq.post(urlPrefix + '/p/api/v1/app/addApp', {
    'app_module_name': data.app_module_name,
    'app_name_i18n': data.app_name_i18n,
    'package': data.package,
    'is_publish': data.is_publish,
    'app_category_id': data.app_category_id,
    'app_type': data.app_type,
    'intro_detail': data.intro_detail || [],
    intro: data.intro,
    remarks: data.remarks,
    img: data.img || ''
  })
}

// 修改应用
const editApp = (data) => {
  return authReq.post(urlPrefix + '/p/api/v1/app/editApp', {
    'app_store_id': data.app_store_id,
    'app_module_name': data.app_module_name,
    'app_name_i18n': data.app_name_i18n,
    'package': data.package,
    'is_publish': data.is_publish,
    'app_category_id': data.app_category_id,
    'app_type': data.app_type,
    'intro_detail': data.intro_detail || [],
    intro: data.intro,
    remarks: data.remarks || '',
    img: data.img || ''
  })
}

// 删除应用
const deleteApp = (data) => {
  return authReq.post(urlPrefix + '/p/api/v1/app/delApp', {
    'app_store_id': data.app_store_id
  })
}

// 获取用户应用列表
const getUserApps = (data) => {
  return authReq.post(urlPrefix + '/p/api/v1/app/getUserAppInner', {
    pageNum: data.page,
    pageSize: data.pageSize || 10,
    step: 'start',
    condition: data.condition || {}
  })
}

// 添加用户应用
const addUserApp = (data) => {
  return authReq.post(urlPrefix + '/p/api/v1/app/addUserAppInner', {
    userid: data.userid,
    app: data.app
  })
}

// 修改用户应用
const editUserApp = (data) => {
  return authReq.post(urlPrefix + '/p/api/v1/app/editUserApp', {
    userid: data.userid,
    'user_app_id': data.user_app_id,
    'expire_at': data.expire_at,
    extend: data.extend,
    status: data.status
  })
}

// 删除用户应用
const deleteUserApp = (data) => {
  return authReq.post(urlPrefix + '/p/api/v1/app/delUserApp', {
    'user_app_id': data.user_app_id
  })
}

// 获取代理商应用列表
const getAgentApps = (data) => {
  return authReq.post(urlPrefix + '/p/api/v1/app/getAgentAppInner', {
    pageNum: data.page,
    pageSize: data.pageSize,
    step: 'start',
    condition: data.condition || {}
  })
}

// 添加代理商应用
const addAgentApp = (data) => {
  return authReq.post(urlPrefix + '/p/api/v1/app/addAgentAppInner', {
    agentid: data.agentid,
    app: data.app
  })
}

// 修改代理商应用
const editAgentApp = (data) => {
  return authReq.post(urlPrefix + '/p/api/v1/app/editAgentApp', {
    agentid: data.agentid,
    'agent_app_id': data.agent_app_id,
    'expire_at': data.expire_at,
    extend: data.extend,
    status: data.status
  })
}

// 删除代理商应用
const deleteAgentApp = (data) => {
  return authReq.post(urlPrefix + '/p/api/v1/app/delAgentApp', {
    'agent_app_id': data.agent_app_id
  })
}

// 获取应用扩展参数
const getAppExtendParams = (data) => {
  return authReq.post(urlPrefix + '/p/api/v1/app/getAppExtendParam', {
    pageNum: data.page,
    step: 'start',
    condition: data.condition || {},
    pageSize: data.pageSize
  })
}

// 添加应用扩展参数
const addAppExtendParam = (data) => {
  return authReq.post(urlPrefix + '/p/api/v1/app/addAppExtendParam', {
    'extend_param_name': data.extend_param_name,
    'app_store_id': data.app_store_id,
    remarks: data.remarks
  })
}

// 修改应用扩展参数
const editAppExtendParam = (data) => {
  return authReq.post(urlPrefix + '/p/api/v1/app/editAppExtendParam', {
    'extend_param_id': data.extend_param_id,
    remarks: data.remarks
  })
}

// 删除应用扩展参数
const deleteAppExtendParam = (data) => {
  return authReq.post(urlPrefix + '/p/api/v1/app/deleteAppExtendParam', {
    'extend_param_id': data.extend_param_id
  })
}

export default {
  // 应用分类
  getAppCategories,
  addAppCategory,
  editAppCategory,

  // 应用
  getApps,
  addApp,
  editApp,
  deleteApp,

  getUserApps,
  addUserApp,
  editUserApp,
  deleteUserApp,

  getAgentApps,
  addAgentApp,
  editAgentApp,
  deleteAgentApp,

  getAppExtendParams,
  addAppExtendParam,
  editAppExtendParam,
  deleteAppExtendParam
}



// WEBPACK FOOTER //
// ./src/api/storeApi.js